import type { Dictionary, DictionaryResource } from '@/typings/index'
import { calcChapterCount } from '@/utils'

// Chinese Examinations
const chinaExam: DictionaryResource[] = [
  {
    id: 'cet4',
    name: 'English Vocabulary',
    description: 'College English Test Vocabulary 1',
    category: 'Chinese Examinations',
    tags: ['College English'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/CET4_T.json',
    length: 2607,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'cet6',
    name: 'English Vocabulary 2',
    description: 'College English Test Vocabulary 2',
    category: 'Chinese Examinations',
    tags: ['College English'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/CET6_T.json',
    length: 2345,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'xinghuoqiaoji_4',
    name: 'Easy Memory and Speed Writing Techniques.',
    description: 'Easy Memory and Speed Writing Techniques.',
    category: 'Chinese Examinations',
    tags: ['College English'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/xinghuoqiaoji_4.json',
    length: 2522,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'xinghuoqiaoji_6',
    name: 'Easy Memory and Speed Writing Techniques. 2',
    description: 'Easy Memory and Speed Writing Techniques.',
    category: 'Chinese Examinations',
    tags: ['College English'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/xinghuoqiaoji_6.json',
    length: 7520,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'cet4-sub',
    name: 'Vocabulary Subtraction',
    description: 'Vocabulary Subtraction.',
    category: 'Chinese Examinations',
    tags: ['College English'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/DanCiDeJianFa_4.json',
    length: 1957,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'cet6-sub',
    name: 'Vocabulary Subtraction 2',
    description: 'Vocabulary Subtraction.',
    category: 'Chinese Examinations',
    tags: ['College English'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/DanCiDeJianFa_6.json',
    length: 1949,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'kaoyan',
    name: 'Graduate School Entrance Examination.',
    description: 'Graduate English Entrance Examination Vocabulary',
    category: 'Chinese Examinations',
    tags: ['Graduate School Entrance Examination.'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/KaoYan_3_T.json',
    length: 3728,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'kaoyan_2024',
    name: 'Graduate School Entrance Examination. 2024',
    description: 'Graduate English Entrance Examination 2024',
    category: 'Chinese Examinations',
    tags: ['Graduate School Entrance Examination.'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/KaoYan_2024.json',
    length: 3731,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'kaoyanshanguo_2023',
    name: 'Missed passing the graduate school entrance exam. 2023',
    description: 'High-Frequency, Intermediate-Frequency, and Low-Frequency Words 2023',
    category: 'Chinese Examinations',
    tags: ['Graduate School Entrance Examination.'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/KaoYanShanGuo_2023.json',
    length: 1771,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'dancimimi_1',
    name: 'The Secret of Words - English Level 1',
    description: 'The Secret of Vocabulary - English Level 1',
    category: 'Chinese Examinations',
    tags: ['Graduate School Entrance Examination.'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/DanCiDeMimi_1.json',
    length: 5657,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'dancimimi_2',
    name: 'The Secret of Vocabulary - English Level 2',
    description: 'The Secret of Words - English Level 2.',
    category: 'Chinese Examinations',
    tags: ['Graduate School Entrance Examination.'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/DanCiDeMimi_2.json',
    length: 3827,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'level4',
    name: 'Vocabulary List',
    description: 'English Major Level 4 Vocabulary List.',
    category: 'Chinese Examinations',
    tags: ['College English'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/Level4luan_2_T.json',
    length: 4025,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'level8',
    name: 'Vocabulary List 2',
    description: 'English Major Level 8 Vocabulary List',
    category: 'Chinese Examinations',
    tags: ['College English'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/Level8luan_2_T.json',
    length: 12197,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'archVocabulary',
    name: 'Architectural English',
    description: 'College Architecture Major English Vocabulary',
    category: 'Chinese Examinations',
    tags: ['Professional English'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/archVocabulary.json',
    length: 630,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'itVocabulary',
    name: 'Computer-Specific English',
    description: 'College Computer Science Major English Vocabulary',
    category: 'Chinese Examinations',
    tags: ['Professional English'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/itVocabulary.json',
    length: 1665,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'pets3',
    name: 'PETS',
    description: 'Commonly Tested Vocabulary in the National English Proficiency Test',
    category: 'Chinese Examinations',
    tags: ['PET'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/PETS_3.json',
    length: 1942,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'pets3-2023',
    name: 'PETS-2023',
    description: 'Frequently Tested Vocabulary in National English Proficiency Exams.',
    category: 'Chinese Examinations',
    tags: ['PET'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/PETS3-2023.json',
    length: 4449,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'coca_20000',
    name: 'COCA20000',
    description: 'COCA 20,000 Words',
    category: 'Chinese Examinations',
    tags: ['other'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/coca20000.json',
    length: 20199,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: '4000_Essential_English_Words1',
    name: 'Essential Words',
    description: '4000 Essential English Words meaning',
    category: 'Chinese Examinations',
    tags: ['other'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/4000_Essential_English_Words-meaning.json',
    length: 3600,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: '4000_Essential_English_Words2',
    name: 'Essential Words',
    description: '4000 Essential English Words sentence',
    category: 'Chinese Examinations',
    tags: ['other'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/4000_Essential_English_Words-sentence.json',
    length: 3600,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'longman_communication_3000_words',
    name: 'Longman Communication 3000',
    description: 'Most frequent words in both spoken and written English',
    category: 'Chinese Examinations',
    tags: ['other'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/Longman_Communication_3000.json',
    length: 3168,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'top_2000_English_Words',
    name: 'Top 2000 words',
    description: 'with highest frequency',
    category: 'Chinese Examinations',
    tags: ['other'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/top2000words.json',
    length: 1867,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'top_1500_nouns_Words',
    name: 'Top 1500 Nouns',
    description: 'with highest frequency',
    category: 'Chinese Examinations',
    tags: ['other'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/Top1500NounWords.json',
    length: 1525,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'top_1000_verb_Words',
    name: 'Top 1000 Verbs',
    description: 'with highest frequency',
    category: 'Chinese Examinations',
    tags: ['other'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/Top1000VerbWords.json',
    length: 1011,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'top_500_Adj_Words',
    name: 'Top 500 adj.',
    description: 'with highest frequency',
    category: 'Chinese Examinations',
    tags: ['other'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/Top500AdjectiveWords.json',
    length: 527,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'top_250_Adv_Words',
    name: 'Top 250 adv.',
    description: 'with highest frequency',
    category: 'Chinese Examinations',
    tags: ['other'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/Top250AdverbWords.json',
    length: 255,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'top_60_Pronouns',
    name: 'Top 60 pron.',
    description: 'with highest frequency',
    category: 'Chinese Examinations',
    tags: ['other'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/Top60Pronouns.json',
    length: 59,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'top_50_Prepositions',
    name: 'Top 50 prep.',
    description: 'with highest frequency',
    category: 'Chinese Examinations',
    tags: ['other'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/Top50Prepositions.json',
    length: 46,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'suffix word',
    name: 'suffix word',
    description: 'common suffix',
    category: 'Chinese Examinations',
    tags: ['other'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/suffix_word.json',
    length: 126,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'word roots1',
    name: 'word roots1',
    description: 'common roots',
    category: 'Chinese Examinations',
    tags: ['other'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/word_roots1.json',
    length: 369,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: '2024HongBao T1',
    name: '2024 GRE English Red Book (Volume 1)',
    description: '2024Must-Know Words from GRE English Red Book (Volume 1)',
    category: 'Chinese Examinations',
    tags: ['other'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/2024HongBao_T1.json',
    length: 997,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: '2024HongBao T2',
    name: '2024 GRE English Red Book (Volume 2)',
    description: '2024 Must-Know Words from GRE English Red Book (Volume 2)',
    category: 'Chinese Examinations',
    tags: ['other'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/2024HongBao_T2.json',
    length: 854,
    language: 'en',
    languageCategory: 'en',
  },
]

// International Examination
const internationalExam: DictionaryResource[] = [
  {
    id: 'gmat',
    name: 'GMAT',
    description: 'GMAT vocabulary bank',
    category: 'International Examination',
    tags: ['GMAT'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/GMAT_3_T.json',
    length: 3047,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'gre',
    name: 'GRE',
    description: 'GRE vocabulary bank',
    category: 'International Examination',
    tags: ['GRE'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/GRE_3_T.json',
    length: 6515,
    language: 'en',
    languageCategory: 'en',
  },

  {
    id: 'ielts',
    name: 'IELTS',
    description: 'IELTS Vocabulary Bank',
    category: 'International Examination',
    tags: ['IELTS'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/IELTS_3_T.json',
    length: 3575,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'ieltsWang3',
    name: 'iELTS King c3',
    description: 'IELTS listening special noun corpus',
    category: 'International Examination',
    tags: ['IELTS'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/IELTS_WANG_3.json',
    length: 1135,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'ieltsWang4',
    name: 'iELTS King c4',
    description: 'IELTS listening adjective adverb corpus',
    category: 'International Examination',
    tags: ['IELTS'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/IELTS_WANG_4.json',
    length: 346,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'ieltsWang5',
    name: 'iELTS King c5',
    description: 'Assimilation and Liaison Mixed Training Corpus',
    category: 'International Examination',
    tags: ['IELTS'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/IELTS_WANG_5.json',
    length: 1569,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'ieltsWang11',
    name: 'iELTS King C11',
    description: 'Comprehensive Test',
    category: 'International Examination',
    tags: ['IELTS'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/IELTS_WANG_11.json',
    length: 1738,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'sat',
    name: 'SAT',
    description: 'SAT Vocabulary for the United States',
    category: 'International Examination',
    tags: ['SAT'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/SAT_3_T.json',
    length: 4464,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'SATen',
    name: 'SAT en-en',
    description: 'SAT English to English',
    category: 'International Examination',
    tags: ['SAT'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/SATen.json',
    length: 2681,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'toefl',
    name: 'TOEFL',
    description: 'Common Words in TOEFL Exam',
    category: 'International Examination',
    tags: ['TOEFL'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/TOEFL_3_T.json',
    length: 4264,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'bec2',
    name: 'Business English',
    description: 'Common Business English Words',
    category: 'International Examination',
    tags: ['BEC'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/BEC_2_T.json',
    length: 2753,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'bec3',
    name: 'BEC',
    description: 'Common Words in BEC Exam',
    category: 'International Examination',
    tags: ['BEC'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/BEC_3_T.json',
    length: 2825,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'PTE_junior',
    name: 'PTE Basic Vocabulary',
    description: '',
    category: 'International Examination',
    tags: ['PTE'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/PTE_junior.json',
    length: 2651,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'PTE_senior',
    name: 'PTE Advanced Vocabulary',
    description: '',
    category: 'International Examination',
    tags: ['PTE'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/PTE_senior.json',
    length: 3170,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'PTE_FIB_R_junior',
    name: 'Reading Fill in the Blanks (FIB) Basic Past Exam Vocabulary',
    description: '',
    category: 'International Examination',
    tags: ['PTE'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/PTE_FIB_R_junior.json',
    length: 941,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'PTE_FIB_R_senior',
    name: 'Reading Fill in the Blanks (FIB) Advanced Past Exam Vocabulary',
    description: '',
    category: 'International Examination',
    tags: ['PTE'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/PTE_FIB_R_senior.json',
    length: 1272,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'PTE_WFD',
    name: 'WFD Past Exam Vocabulary',
    description: '',
    category: 'International Examination',
    tags: ['PTE'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/PTE_WFD.json',
    length: 1212,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'PTE_FIB_L',
    name: 'Listening Fill in the Blanks (FIB) Past Exam Vocabulary',
    description: '',
    category: 'International Examination',
    tags: ['PTE'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/PTE_FIB_L.json',
    length: 646,
    language: 'en',
    languageCategory: 'en',
  },
]

// English for Children
const childrenEnglish: DictionaryResource[] = [
  {
    id: 'gaokao3500',
    name: 'College Entrance Examination 3500 Words',
    description: 'Commonly Tested Words in the College Entrance Examination - 3500 Words',
    category: 'English for Teenagers',
    tags: ['common'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/GaoKao_3500.json',
    length: 3893,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'gaokaozhentihexin',
    name: 'High-Frequency Core Questions from Past College Entrance Examinations',
    description: 'High-Frequency Core Questions from Past College Entrance Examinations',
    category: 'English for Teenagers',
    tags: ['common'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/GaoKaoZhenTiHeXinGaoPin.json',
    length: 799,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'zhongkaohexin',
    name: 'Core Words for the Secondary School Entrance Examination',
    description: 'Core Vocabulary for the Junior High School Entrance Examination',
    category: 'English for Teenagers',
    tags: ['common'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/ZhongKaoHeXin.json',
    length: 2140,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'nce1',
    name: 'New Concept English - Book 1',
    description: 'New Concept English Volume One',
    category: 'English for Teenagers',
    tags: ['New Concept English'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/NCE_1.json',
    length: 900,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'nce2',
    name: 'New Concept English - Book 2',
    description: 'New Concept English Volume Two',
    category: 'English for Teenagers',
    tags: ['New Concept English'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/NCE_2.json',
    length: 858,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'nce3',
    name: 'New Concept English - Book 3',
    description: 'New Concept English Volume Three',
    category: 'English for Teenagers',
    tags: ['New Concept English'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/NCE_3.json',
    length: 1052,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'nce4',
    name: 'New Concept English - Book 4',
    description: 'New Concept English Volume Four',
    category: 'English for Teenagers',
    tags: ['New Concept English'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/NCE_4.json',
    length: 784,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'SHjuniormiddleOxford',
    name: 'Oxford Vocabulary for Junior High Schools',
    description: 'Oxford Vocabulary for Junior High Schools',
    category: 'English for Teenagers',
    tags: ['Oxford Edition'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/OxfordVocabulary_juniorMiddleSH.json',
    length: 1270,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'san1',
    name: 'Grade 3, Semester 1',
    description: "Grade 3, Semester 1, People's Education Edition",
    category: 'English for Teenagers',
    tags: ["People's Education Edition"],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/PEPXiaoXue3_1_T.json',
    length: 64,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'san2',
    name: 'Grade 3, Semester 2',
    description: "Grade 3, Semester 2, People's Education Edition",
    category: 'English for Teenagers',
    tags: ["People's Education Edition"],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/PEPXiaoXue3_2_T.json',
    length: 72,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'si1',
    name: 'Grade 4, Semester 1',
    description: "Grade 4, Semester 1, People's Education Edition",
    category: 'English for Teenagers',
    tags: ["People's Education Edition"],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/PEPXiaoXue4_1_T.json',
    length: 84,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'si2',
    name: 'Grade 4, Semester 2',
    description: "Grade 4, Semester 2, People's Education Edition",
    category: 'English for Teenagers',
    tags: ["People's Education Edition"],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/PEPXiaoXue4_2_T.json',
    length: 104,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'wu1',
    name: 'Grade 5, Semester 1',
    description: "Grade 5, Semester 1, People's Education Edition",
    category: 'English for Teenagers',
    tags: ["People's Education Edition"],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/PEPXiaoXue5_1_T.json',
    length: 131,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'wu2',
    name: 'Grade 5, Semester 2',
    description: "Grade 5, Semester 2, People's Education Edition",
    category: 'English for Teenagers',
    tags: ["People's Education Edition"],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/PEPXiaoXue5_2_T.json',
    length: 156,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'liu1',
    name: 'Grade 6, Semester 1',
    description: "Grade 6, Semester 1, People's Education Edition",
    category: 'English for Teenagers',
    tags: ["People's Education Edition"],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/PEPXiaoXue6_1_T.json',
    length: 130,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'liu2',
    name: 'Grade 6, Semester 2',
    description: "Grade 6, Semester 2, People's Education Edition",
    category: 'English for Teenagers',
    tags: ["People's Education Edition"],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/PEPXiaoXue6_2_T.json',
    length: 108,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'qi1',
    name: 'Grade 7, Semester 1',
    description: "Grade 7, Semester 1, People's Education Edition",
    category: 'English for Teenagers',
    tags: ["People's Education Edition"],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/PEPChuZhong7_1_T.json',
    length: 392,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'qi2',
    name: 'Grade 7, Semester 2',
    description: "Grade 7, Semester 2, People's Education Edition",
    category: 'English for Teenagers',
    tags: ["People's Education Edition"],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/PEPChuZhong7_2_T.json',
    length: 492,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'ba1',
    name: 'Grade 8, Semester 1',
    description: "Grade 8, Semester 1, People's Education Edition",
    category: 'English for Teenagers',
    tags: ["People's Education Edition"],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/PEPChuZhong8_1_T.json',
    length: 419,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'ba2',
    name: 'Grade 8, Semester 2',
    description: "Grade 8, Semester 2, People's Education Edition",
    category: 'English for Teenagers',
    tags: ["People's Education Edition"],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/PEPChuZhong8_2_T.json',
    length: 466,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'jiu',
    name: 'Grade 9',
    description: "Grade 9, Full Set, People's Education Edition",
    category: 'English for Teenagers',
    tags: ["People's Education Edition"],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/PEPChuZhong9_1_T.json',
    length: 551,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'renjiaogaozhong1',
    name: 'High School Compulsory Course 1',
    description: "High School Compulsory Course 1, People's Education Edition",
    category: 'English for Teenagers',
    tags: ["People's Education Edition"],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/PEPGaoZhong_1_T.json',
    length: 311,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'renjiaogaozhong2',
    name: 'High School Compulsory Course 2',
    description: "High School Compulsory Course 2, People's Education Edition",
    category: 'English for Teenagers',
    tags: ["People's Education Edition"],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/PEPGaoZhong_2_T.json',
    length: 319,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'renjiaogaozhong3',
    name: '"High School Compulsory Course 3"',
    description: "High School Compulsory Course 3, People's Education Edition",
    category: 'English for Teenagers',
    tags: ["People's Education Edition"],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/PEPGaoZhong_3_T.json',
    length: 366,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'renjiaogaozhong4',
    name: '高中必修4',
    description: '人教版高中必修4',
    category: 'English for Teenagers',
    tags: ["People's Education Edition"],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/PEPGaoZhong_4_T.json',
    length: 307,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'renjiaogaozhong5',
    name: 'High School Compulsory Course 5',
    description: "High School Compulsory Course 5, People's Education Edition",
    category: 'English for Teenagers',
    tags: ["People's Education Edition"],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/PEPGaoZhong_5_T.json',
    length: 357,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'renjiaogaozhong6',
    name: 'High School Elective Course 6',
    description: "High School Elective Course 6, People's Education Edition",
    category: 'English for Teenagers',
    tags: ["People's Education Edition"],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/PEPGaoZhong_6_T.json',
    length: 391,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'renjiaogaozhong7',
    name: 'High School Elective Course 7',
    description: "High School Elective Course 7, People's Education Edition",
    category: 'English for Teenagers',
    tags: ["People's Education Edition"],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/PEPGaoZhong_7_T.json',
    length: 384,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'renjiaogaozhong8',
    name: 'High School Elective Course 8',
    description: "High School Elective Course 8, People's Education Edition",
    category: 'English for Teenagers',
    tags: ["People's Education Edition"],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/PEPGaoZhong_8_T.json',
    length: 420,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'renjiaogaozhong9',
    name: 'High School Elective Course 9',
    description: "High School Elective Course 9, People's Education Edition",
    category: 'English for Teenagers',
    tags: ["People's Education Edition"],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/PEPGaoZhong_9_T.json',
    length: 352,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'renjiaogaozhong10',
    name: '"High School Elective Course 10"',
    description: "High School Elective Course 10, People's Education Edition",
    category: 'English for Teenagers',
    tags: ["People's Education Edition"],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/PEPGaoZhong_10_T.json',
    length: 361,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'renjiaogaozhong11',
    name: 'High School Elective Course 11',
    description: "High School Elective Course 11, People's Education Edition",
    category: 'English for Teenagers',
    tags: ["People's Education Edition"],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/PEPGaoZhong_11_T.json',
    length: 309,
    language: 'en',
    languageCategory: 'en',
  },

  {
    id: 'waiyan1',
    name: 'Grade 7, Semester 1, Foreign Language Teaching and Research Press Edition',
    description: 'Grade 7, Semester 1, Foreign Language Teaching and Research Press Edition',
    category: 'English for Teenagers',
    tags: ['Foreign Language Teaching and Research Press Edition'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/WaiYanSheChuZhong_1_T.json',
    length: 629,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'waiyan2',
    name: 'Grade 7, Semester 2, Foreign Language Teaching and Research Press Edition',
    description: 'Grade 7, Semester 2, Foreign Language Teaching and Research Press Edition',
    category: 'English for Teenagers',
    tags: ['Foreign Language Teaching and Research Press Edition'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/WaiYanSheChuZhong_2_T.json',
    length: 438,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'waiyan3',
    name: 'Grade 8, Semester 1, Foreign Language Teaching and Research Press Edition',
    description: 'Grade 8, Semester 1, Foreign Language Teaching and Research Press Edition',
    category: 'English for Teenagers',
    tags: ['Foreign Language Teaching and Research Press Edition'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/WaiYanSheChuZhong_3_T.json',
    length: 320,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'waiyan4',
    name: 'Grade 8, Semester 2, Foreign Language Teaching and Research Press Edition',
    description: 'Grade 8, Semester 2, Foreign Language Teaching and Research Press Edition',
    category: 'English for Teenagers',
    tags: ['Foreign Language Teaching and Research Press Edition'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/WaiYanSheChuZhong_4_T.json',
    length: 266,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'waiyan5',
    name: 'Grade 9, Semester 1, Foreign Language Teaching and Research Press Edition',
    description: 'Grade 9, Semester 1, Foreign Language Teaching and Research Press Edition',
    category: 'English for Teenagers',
    tags: ['Foreign Language Teaching and Research Press Edition'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/WaiYanSheChuZhong_5_T.json',
    length: 381,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'waiyan6',
    name: 'Grade 9, Semester 2, Foreign Language Teaching and Research Press Edition',
    description: 'Grade 9, Semester 2, Foreign Language Teaching and Research Press Edition',
    category: 'English for Teenagers',
    tags: ['Foreign Language Teaching and Research Press Edition'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/WaiYanSheChuZhong_6_T.json',
    length: 128,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'waiyan7',
    name: 'Senior High School Compulsory 1',
    description: 'Senior High School Compulsory 1',
    category: 'English for Teenagers',
    tags: ['Foreign Language Teaching and Research Press Edition'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/WaiYanSheGaoZhong_1_T.json',
    length: 411,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'waiyan8',
    name: 'Senior High School Compulsory 2',
    description: 'Senior High School Compulsory 2',
    category: 'English for Teenagers',
    tags: ['Foreign Language Teaching and Research Press Edition'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/WaiYanSheGaoZhong_2_T.json',
    length: 272,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'beishi1',
    name: 'High School Compulsory 1',
    description: 'University Edition Senior High School Compulsory 1',
    category: 'English for Teenagers',
    tags: ['University'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/BeiShiGaoZhong_1_T.json',
    length: 226,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'beishi2',
    name: 'High School Compulsory 2',
    description: 'University Edition Senior High School Compulsory 2',
    category: 'English for Teenagers',
    tags: ['University'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/BeiShiGaoZhong_2_T.json',
    length: 244,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'beishi3',
    name: 'High School Compulsory 3',
    description: 'University Edition Senior High School Compulsory 3',
    category: 'English for Teenagers',
    tags: ['University'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/BeiShiGaoZhong_3_T.json',
    length: 295,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'beishi4',
    name: 'High School Compulsory 4',
    description: 'University Edition Senior High School Compulsory 4',
    category: 'English for Teenagers',
    tags: ['University'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/BeiShiGaoZhong_4_T.json',
    length: 336,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'beishi5',
    name: 'High School Compulsory 5',
    description: 'University Edition Senior High School Compulsory 5',
    category: 'English for Teenagers',
    tags: ['University'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/BeiShiGaoZhong_5_T.json',
    length: 327,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'beishi6',
    name: 'High School Elective 6',
    description: 'University Edition High School Elective 6',
    category: 'English for Teenagers',
    tags: ['University'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/BeiShiGaoZhong_6_T.json',
    length: 271,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'beishi7',
    name: 'High School Elective 7',
    description: 'University Edition High School Elective 7',
    category: 'English for Teenagers',
    tags: ['University'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/BeiShiGaoZhong_7_T.json',
    length: 334,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'beishi8',
    name: 'High School Elective 8',
    description: 'University Edition Senior High School Elective 8',
    category: 'English for Teenagers',
    tags: ['University'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/BeiShiGaoZhong_8_T.json',
    length: 364,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'beishi9',
    name: 'High School Elective 9',
    description: 'University Edition High School Elective 9',
    category: 'English for Teenagers',
    tags: ['University'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/BeiShiGaoZhong_9_T.json',
    length: 299,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'beishi10',
    name: 'High School Elective 10',
    description: 'University Edition Senior High School Elective 10',
    category: 'English for Teenagers',
    tags: ['University'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/BeiShiGaoZhong_10_T.json',
    length: 267,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'beishi11',
    name: 'High School Elective 11',
    description: 'University Edition Senior High School Elective 11',
    category: 'English for Teenagers',
    tags: ['University'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/BeiShiGaoZhong_11_T.json',
    length: 330,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'eflevel1',
    name: 'EF-LEVEL-1',
    description: 'EF level 1',
    category: 'English for Teenagers',
    tags: ['EF'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/EF_LEVEL_1.json',
    length: 297,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'eflevel2',
    name: 'EF-LEVEL-2',
    description: 'EF level 2',
    category: 'English for Teenagers',
    tags: ['EF'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/EF_LEVEL_2.json',
    length: 353,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'eflevel3',
    name: 'EF-LEVEL-3',
    description: 'EF level 3',
    category: 'English for Teenagers',
    tags: ['EF'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/EF_LEVEL_3.json',
    length: 172,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'eflevel4',
    name: 'EF-LEVEL-4',
    description: 'EF level 4',
    category: 'English for Teenagers',
    tags: ['EF'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/EF_LEVEL_4.json',
    length: 178,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'eflevel5',
    name: 'EF-LEVEL-5',
    description: 'EF level 5',
    category: 'English for Teenagers',
    tags: ['EF'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/EF_LEVEL_5.json',
    length: 172,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'eflevel6',
    name: 'EF-LEVEL-6',
    description: 'EF level 6',
    category: 'English for Teenagers',
    tags: ['EF'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/EF_LEVEL_6.json',
    length: 172,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'eflevel7',
    name: 'EF-LEVEL-7',
    description: 'EF level 7',
    category: 'English for Teenagers',
    tags: ['EF'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/EF_LEVEL_7.json',
    length: 171,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'eflevel8',
    name: 'EF-LEVEL-8',
    description: 'EF level 8',
    category: 'English for Teenagers',
    tags: ['EF'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/EF_LEVEL_8.json',
    length: 172,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'eflevel9',
    name: 'EF-LEVEL-9',
    description: 'EF level 9',
    category: 'English for Teenagers',
    tags: ['EF'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/EF_LEVEL_9.json',
    length: 165,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'eflevel10',
    name: 'EF-LEVEL-10',
    description: 'EF level 10',
    category: 'English for Teenagers',
    tags: ['EF'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/EF_LEVEL_10.json',
    length: 174,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'eflevel11',
    name: 'EF-LEVEL-11',
    description: 'EF level 11',
    category: 'English for Teenagers',
    tags: ['EF'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/EF_LEVEL_11.json',
    length: 176,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'eflevel12',
    name: 'EF-LEVEL-12',
    description: 'EF level 12',
    category: 'English for Teenagers',
    tags: ['EF'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/EF_LEVEL_12.json',
    length: 170,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'eflevel13',
    name: 'EF-LEVEL-13',
    description: 'EF level 13',
    category: 'English for Teenagers',
    tags: ['EF'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/EF_LEVEL_13.json',
    length: 172,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'eflevel14',
    name: 'EF-LEVEL-14',
    description: 'EF level 14',
    category: 'English for Teenagers',
    tags: ['EF'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/EF_LEVEL_14.json',
    length: 171,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'eflevel15',
    name: 'EF-LEVEL-15',
    description: 'EF level 15',
    category: 'English for Teenagers',
    tags: ['EF'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/EF_LEVEL_15.json',
    length: 168,
    language: 'en',
    languageCategory: 'en',
  },
  {
    id: 'eflevel16',
    name: 'EF-LEVEL-16',
    description: 'EF level 16',
    category: 'English for Teenagers',
    tags: ['EF'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/EF_LEVEL_16.json',
    length: 170,
    language: 'en',
    languageCategory: 'en',
  },
]
// programming dictionary
const programming: DictionaryResource[] = [
  {
    id: 'coder',
    name: 'Coder Dict',
    description: 'Thesaurus of Common Words for Programmers',
    category: 'Code Exercise',
    tags: ['common'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/it-words.json',
    length: 1700,
    language: 'code',
    languageCategory: 'code',
  },
  {
    id: 'childCode',
    name: "Children's Python",
    description: 'Common Words in Python for Kids',
    category: 'Code Exercise',
    tags: ['Kids Programming', 'Python'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/Child_python_code.json',
    length: 19,
    language: 'en',
    languageCategory: 'code',
  },
  {
    id: 'childCode002',
    name: 'Kids Python Turtle',
    description: 'Common Words for Kids with Python Turtle',
    category: 'Code Exercise',
    tags: ['Kids Programming', 'Python'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/Child_python_turtle_code.json',
    length: 27,
    language: 'en',
    languageCategory: 'code',
  },
  {
    id: 'childCode003',
    name: 'Junior C',
    description: 'Junior C Common Words',
    category: 'Code Exercise',
    tags: ['Kids Programming', 'C++'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/Child_c++.json',
    length: 39,
    language: 'en',
    languageCategory: 'code',
  },

  {
    id: 'jsArray',
    name: 'JS: Array',
    description: 'Dictionary of JavaScript APIs',
    category: 'Code Exercise',
    tags: ['JavaScript'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/js-array.json',
    length: 36,
    language: 'code',
    languageCategory: 'code',
  },
  {
    id: 'jsDate',
    name: 'JS: Date',
    description: 'Dictionary of JavaScript APIs',
    category: 'Code Exercise',
    tags: ['JavaScript'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/js-date.json',
    length: 34,
    language: 'code',
    languageCategory: 'code',
  },
  {
    id: 'jsGlobal',
    name: 'JS: Global',
    description: 'Dictionary of JavaScript APIs',
    category: 'Code Exercise',
    tags: ['JavaScript'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/js-global.json',
    length: 9,
    language: 'code',
    languageCategory: 'code',
  },
  {
    id: 'jsMapSet',
    name: 'JS: Map & Set',
    description: 'Dictionary of JavaScript APIs',
    category: 'Code Exercise',
    tags: ['JavaScript'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/js-map-set.json',
    length: 16,
    language: 'code',
    languageCategory: 'code',
  },
  {
    id: 'jsMath',
    name: 'JS: Math',
    description: 'Dictionary of JavaScript APIs',
    category: 'Code Exercise',
    tags: ['JavaScript'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/js-math.json',
    length: 38,
    language: 'code',
    languageCategory: 'code',
  },
  {
    id: 'jsNumber',
    name: 'JS: Number',
    description: 'Dictionary of JavaScript APIs',
    category: 'Code Exercise',
    tags: ['JavaScript'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/js-number.json',
    length: 22,
    language: 'code',
    languageCategory: 'code',
  },
  {
    id: 'jsObject',
    name: 'JS: Object',
    description: 'Dictionary of JavaScript APIs',
    category: 'Code Exercise',
    tags: ['JavaScript'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/js-object.json',
    length: 37,
    language: 'code',
    languageCategory: 'code',
  },
  {
    id: 'jsPromise',
    name: 'JS: Promise',
    description: 'Dictionary of JavaScript APIs',
    category: 'Code Exercise',
    tags: ['JavaScript'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/js-promise.json',
    length: 9,
    language: 'code',
    languageCategory: 'code',
  },
  {
    id: 'jsString',
    name: 'JS: String',
    description: 'Dictionary of JavaScript APIs',
    category: 'Code Exercise',
    tags: ['JavaScript'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/js-string.json',
    length: 32,
    language: 'code',
    languageCategory: 'code',
  },
  {
    id: 'python-builtin',
    name: 'Python: Built-in',
    description: 'Python Built-in API',
    category: 'Code Exercise',
    tags: ['Python'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/python-builtin.json',
    length: 65,
    language: 'code',
    languageCategory: 'code',
  },
  {
    id: 'python-array',
    name: 'Python: array',
    description: 'Python array API ',
    category: 'Code Exercise',
    tags: ['Python'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/python-array.json',
    length: 11,
    language: 'code',
    languageCategory: 'code',
  },
  {
    id: 'python-date',
    name: 'Python: date',
    description: 'Python date API ',
    category: 'Code Exercise',
    tags: ['Python'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/python-date.json',
    length: 39,
    language: 'code',
    languageCategory: 'code',
  },
  {
    id: 'python-file',
    name: 'Python: file',
    description: 'Python file API ',
    category: 'Code Exercise',
    tags: ['Python'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/python-file.json',
    length: 21,
    language: 'code',
    languageCategory: 'code',
  },
  {
    id: 'python-class',
    name: 'Python: class',
    description: 'Python class API ',
    category: 'Code Exercise',
    tags: ['Python'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/python-class.json',
    length: 13,
    language: 'code',
    languageCategory: 'code',
  },
  {
    id: 'python-set',
    name: 'Python: set',
    description: 'Python set API ',
    category: 'Code Exercise',
    tags: ['Python'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/python-set.json',
    length: 29,
    language: 'code',
    languageCategory: 'code',
  },
  {
    id: 'python-math',
    name: 'Python: math',
    description: 'Python math API ',
    category: 'Code Exercise',
    tags: ['Python'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/python-math.json',
    length: 37,
    language: 'code',
    languageCategory: 'code',
  },
  {
    id: 'python-string',
    name: 'Python: string',
    description: 'Python string API ',
    category: 'Code Exercise',
    tags: ['Python'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/python-string.json',
    length: 40,
    language: 'code',
    languageCategory: 'code',
  },
  {
    id: 'python-system',
    name: 'Python: system',
    description: 'Python system API ',
    category: 'Code Exercise',
    tags: ['Python'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/python-sys.json',
    length: 24,
    language: 'code',
    languageCategory: 'code',
  },
  {
    id: 'javeArrayList',
    name: 'Java: ArrayList',
    description: 'Dictionary of JavaScript APIs',
    category: 'Code Exercise',
    tags: ['Java'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/java-arraylist.json',
    length: 25,
    language: 'code',
    languageCategory: 'code',
  },
  {
    id: 'javaCharacter',
    name: 'Java: Character',
    description: 'Dictionary of JavaScript APIs',
    category: 'Code Exercise',
    tags: ['Java'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/java-character.json',
    length: 8,
    language: 'code',
    languageCategory: 'code',
  },
  {
    id: 'javaHashmap',
    name: 'Java: Hashmap',
    description: 'Dictionary of JavaScript APIs',
    category: 'Code Exercise',
    tags: ['Java'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/java-hashmap.json',
    length: 22,
    language: 'code',
    languageCategory: 'code',
  },
  {
    id: 'javaLinkedList',
    name: 'Java: LinkedList',
    description: 'Dictionary of JavaScript APIs',
    category: 'Code Exercise',
    tags: ['Java'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/java-linkedlist.json',
    length: 25,
    language: 'code',
    languageCategory: 'code',
  },
  {
    id: 'javaString',
    name: 'Java: String',
    description: 'Dictionary of JavaScript APIs',
    category: 'Code Exercise',
    tags: ['Java'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/java-string.json',
    length: 48,
    language: 'code',
    languageCategory: 'code',
  },
  {
    id: 'javaStringBuffer',
    name: 'Java: StringBuffer',
    description: 'Dictionary of JavaScript APIs',
    category: 'Code Exercise',
    tags: ['Java'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/java-stringBuffer.json',
    length: 20,
    language: 'code',
    languageCategory: 'code',
  },
  {
    id: 'linuxCommand',
    name: 'Linux',
    description: 'Linux Command',
    category: 'Code Exercise',
    tags: ['Linux'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/linux-command.json',
    length: 575,
    language: 'code',
    languageCategory: 'code',
  },
  {
    id: 'csharpList',
    name: 'C#: List API',
    description: 'C# List API',
    category: 'Code Exercise',
    tags: ['C#'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/csharp-list.json',
    length: 36,
    language: 'code',
    languageCategory: 'code',
  },
  {
    id: 'sql-lower-case',
    name: 'SQL: common statement lower case',
    description: 'Commonly used SQL statements lowercase',
    category: 'Code Exercise',
    tags: ['SQL'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/SQL_statement_lower-case.json',
    length: 12,
    language: 'code',
    languageCategory: 'code',
  },
  {
    id: 'sql-upper-case',
    name: 'SQL: common statement upper case',
    description: 'Commonly used SQL statements Uppercase',
    category: 'Code Exercise',
    tags: ['SQL'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/SQL_statement_upper-case.json',
    length: 12,
    language: 'code',
    languageCategory: 'code',
  },
]

// Japanese dictionary
const japaneseExam: DictionaryResource[] = [
  {
    id: 'japanese001',
    name: 'Japanese common words',
    description: 'Japanese common words',
    category: 'Japanese learning',
    tags: ['Base'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/Japanesebasicword.json',
    length: 100,
    language: 'romaji',
    languageCategory: 'ja',
  },
  {
    id: 'japanese002',
    name: 'N5',
    description: 'Japanese N5',
    category: 'Japanese learning',
    tags: ['Base'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/JapVocabList.N5.json',
    length: 670,
    language: 'romaji',
    languageCategory: 'ja',
  },
  {
    id: 'japanese003',
    name: 'N4',
    description: 'Japanese N4',
    category: 'Japanese learning',
    tags: ['Base'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/JapVocabList.N4.json',
    length: 635,
    language: 'romaji',
    languageCategory: 'ja',
  },
  {
    id: 'japanese004',
    name: 'N3',
    description: 'Japanese N3',
    category: 'Japanese learning',
    tags: ['Base'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/JapVocabList.N3.json',
    length: 1830,
    language: 'romaji',
    languageCategory: 'ja',
  },
  {
    id: 'japanese005',
    name: 'N2',
    description: 'Japanese N2',
    category: 'Japanese learning',
    tags: ['Base'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/JapVocabList.N2.json',
    length: 1836,
    language: 'romaji',
    languageCategory: 'ja',
  },
  {
    id: 'japanese006',
    name: 'N1',
    description: 'Japanese N1',
    category: 'Japanese learning',
    tags: ['Base'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/JapVocabList.N1.json',
    length: 3477,
    language: 'romaji',
    languageCategory: 'ja',
  },
  {
    id: 'japanese007',
    name: 'High-frequency words_N1',
    description: 'High-frequency words_Japanese N1',
    category: 'Japanese learning',
    tags: ['Base'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/Jap_High-Frequency_N1.json',
    length: 3000,
    language: 'romaji',
    languageCategory: 'ja',
  },
  {
    id: 'japanese008',
    name: 'High-frequency words_N2',
    description: 'High-frequency words_Japanese N2',
    category: 'Japanese learning',
    tags: ['Base'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/Jap_High-Frequency_N2.json',
    length: 2500,
    language: 'romaji',
    languageCategory: 'ja',
  },
  {
    id: 'japanese009',
    name: 'High-frequency words_N3',
    description: 'High-frequency words_Japanese N3',
    category: 'Japanese learning',
    tags: ['Base'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/Jap_High-Frequency_N3.json',
    length: 1999,
    language: 'romaji',
    languageCategory: 'ja',
  },
  {
    id: 'japanese0010',
    name: 'High-frequency words_N4N5',
    description: 'High-frequency words_Japanese N4N5',
    category: 'Japanese learning',
    tags: ['Base'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/Jap_High-Frequency_N4N5.json',
    length: 2000,
    language: 'romaji',
    languageCategory: 'ja',
  },
]

// german dictionary
const germanExam: DictionaryResource[] = [
  {
    id: 'german2en',
    name: 'German English translation',
    description: 'german vocabulary, English translation',
    category: 'a',
    tags: ['Base'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/german2en.json',
    length: 5892,
    language: 'de',
    languageCategory: 'de',
  },
  {
    id: 'en2german',
    name: 'English German translation',
    description: 'English vocabulary, German translation',
    category: 'a',
    tags: ['Base'],
    url: import.meta.env.VITE_APP_HOME_URL + 'dicts/en2german.json',
    length: 5025,
    language: 'en',
    languageCategory: 'de',
  },
]

/**
 * Built-in dictionaries in an array.
 * Why arrays? Because it keeps the order across browsers.
 */
export const dictionaryResources: DictionaryResource[] = [
  ...chinaExam,
  ...internationalExam,
  ...childrenEnglish,
  ...programming,
  ...japaneseExam,
  ...germanExam,

  // {
  //   id: 'zhtest',
  //   name: '中文测试',
  //   description: '中文测试词库',
  //   category: '测试',
  //   url: import.meta.env.VITE_APP_HOME_URL+'dicts/chinese_test.json',
  //   length: 27,
  //   language: 'zh',
  // },
  // {
  //   id: 'jptest',
  //   name: '日文测试',
  //   description: '日文测试词库',
  //   category: '测试',
  //   url: import.meta.env.VITE_APP_HOME_URL+'dicts/japanese_test.json',
  //   length: 20,
  //   language: 'ja',
  // },
]

export const dictionaries: Dictionary[] = dictionaryResources.map((resource) => ({
  ...resource,
  chapterCount: calcChapterCount(resource.length),
}))

/**
 * An object-map from dictionary IDs to dictionary themselves.
 */
export const idDictionaryMap: Record<string, Dictionary> = Object.fromEntries(dictionaries.map((dict) => [dict.id, dict]))
